import styled, { css } from '../../styled';
import { StyledInput } from '../input';
export const InputFocusBgWrapper = styled.div `
  flex: 1;
  position: relative;

  ${StyledInput} {
    position: relative;
    background-color: transparent;

    &:hover:enabled,
    &:focus:enabled {
      background-color: transparent;
    }
  }

  :nth-child(n + 1) {
    padding-right: 0.5rem;
  }
`;
export const InputFocusBg = styled.div `
${({ focusColor, theme, inputSize = 'MEDIUM' }) => css `
    display: block;
    background-color: ${focusColor || theme.colors.PRIMARY_400};
    color: ${focusColor || theme.colors.PRIMARY_400};
    position: absolute;
    top: 8px;
    left: 0;
    height: 18px;
    font-size: ${theme.inputs.size[inputSize].fontSize};
    max-width: calc(100% - 0.5rem);
    overflow: hidden;
    padding: 0 0.25rem;
  `}}
`;
//# sourceMappingURL=styled.js.map